import { TextField, TextFieldProps, styled } from "@mui/material";

const StyledTextFieldView = styled(TextField)(({ theme }) => ({}));

export const StyledTextField = (props: TextFieldProps) => {
  return (
    <StyledTextFieldView
      {...props}
      fullWidth
      inputProps={{
        maxLength: 100,
      }}
      InputProps={{
        ...props.InputProps,
      }}
    />
  );
};
